import { FileWithPath } from "@mantine/dropzone"
import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { httpClient } from "~/backend/axios"

type ErrorContent = {
  [errorType: string]: string
}

export type ErrorLogs = {
  title: string
  content: ErrorContent
}

type SupplierBatchCreateRequest = {
  file: FileWithPath
}

export const useBatchCreateSuppliersMutation = (
  options?: UseMutationOptions<number, AxiosError, SupplierBatchCreateRequest>
) =>
  useMutation({
    mutationFn: async ({ file }: SupplierBatchCreateRequest) => {
      const formData = new FormData()
      formData.set("file", file)

      const response = await httpClient.post(
        "/v1/client-settings/batch-create-supplier-mapping",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )

      return response.data
    },

    ...options,
  })
